/* eslint-disable no-console */

// import "./google-sign-in__large--black.scss"
import "./google-sign-in_large--white.scss"
// import "./google-sign-up__large--white.scss"

function initGoogleSignIn() {
  const customBtn = document.getElementById("custom-google-signin")
  if (!customBtn) return

  const customBtnEl = customBtn
  const clientId = customBtnEl.getAttribute("data-client-id") || ""
  const nonce = customBtnEl.getAttribute("data-nonce") || undefined

  // Avoid capturing window.google too early; always read fresh
  function getGoogle() {
    return (window as any).google
  }

  let gisReady = false
  let pendingPrompt = false
  let popupFallbackUsed = false

  function showGoogleSignInMessage(message: string) {
    const existing = document.getElementById("google-signin-message")
    const el = existing || document.createElement("div")

    if (!existing) {
      const htmlEl = el as HTMLElement
      el.id = "google-signin-message"
      el.setAttribute("role", "status")
      el.setAttribute("aria-live", "polite")
      htmlEl.style.marginTop = "0.5rem"
      htmlEl.style.fontSize = "0.875rem"
      customBtnEl.insertAdjacentElement("afterend", el)
    }

    el.textContent = message
  }

  const onCredential = (response: any) => {
    const credential = response?.credential
    if (!credential) {
      console.error("Sign in with Google failed: Missing credential")
      return
    }

    fetch("/auth/google/handle_success", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token":
          document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
      },
      body: JSON.stringify({ credential }),
    })
      .then((res) => {
        if (res.ok) {
          window.location.href = "/profile"
        } else {
          res.json().then((data) => {
            console.error(`Sign in with Google failed: ${data.message || "Please try again."}`)
          })
        }
      })
      .catch((error) => {
        console.error(`An error occurred during sign in. Please try again. Error: ${error.message}`)
      })
  }

  const openGoogleLoginWindow = () => {
    const features = "width=500,height=600,menubar=0,toolbar=0,status=0"
    window.open(
      "https://accounts.google.com/signin/v2/identifier?continue=https%3A%2F%2Fwww.google.com%2F",
      "_blank",
      features,
    )
  }

  function initializeGsi(useFedcm: boolean) {
    const g = getGoogle()
    if (!g?.accounts?.id) return
    g.accounts.id.initialize({
      client_id: clientId,
      callback: onCredential,
      nonce,
      ux_mode: "popup",
      itp_support: true,
      use_fedcm_for_prompt: useFedcm,
      auto_select: false,
    })
  }

  function promptWithFallback(notificationHandler: (notification: any) => void) {
    const g = getGoogle()
    g?.accounts?.id?.prompt(notificationHandler)
  }

  function switchToPopupFallback(notificationHandler: (notification: any) => void) {
    if (popupFallbackUsed) return
    popupFallbackUsed = true
    initializeGsi(false)
    promptWithFallback(notificationHandler)
  }

  function handlePromptMoment(notification: any) {
    const notDisplayedReason = notification.getNotDisplayedReason?.()
    const skippedReason = notification.getSkippedReason?.()

    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
      // Prefer FedCM, but fall back to legacy popup when there is no Google session
      if (
        !popupFallbackUsed &&
        (notDisplayedReason === "opt_out_or_no_session" || !notDisplayedReason)
      ) {
        switchToPopupFallback(handlePromptMoment)
        return
      }

      // If popup is also blocked, last resort guidance
      if (notDisplayedReason === "opt_out_or_no_session") {
        openGoogleLoginWindow()
      } else {
        showGoogleSignInMessage(
          "Google sign-in could not start. Please allow popups and ensure you are signed in to your Google account.",
        )
      }
      if (notDisplayedReason || skippedReason) {
        console.warn("Google sign-in prompt skipped", { notDisplayedReason, skippedReason })
      }
    }
  }

  const ensureRendered = () => {
    try {
      const g = getGoogle()
      if (!g?.accounts?.id) return
      initializeGsi(true)
      gisReady = true
      const container = document.getElementById("googleid-signin")
      if (container) {
        g.accounts.id.renderButton(container, { theme: "outline", size: "large" })
      }

      if (pendingPrompt) {
        pendingPrompt = false
        promptWithFallback(handlePromptMoment)
      }
    } catch (e) {
      // noop
    }
  }

  // Register click handler immediately so the button works even if GIS loads slowly
  const triggerGoogle = () => {
    const g = getGoogle()
    if (g?.accounts?.id && gisReady) {
      promptWithFallback(handlePromptMoment)
    } else {
      // Defer until GIS is ready
      pendingPrompt = true
    }
  }

  customBtnEl.addEventListener("click", (e) => {
    e.preventDefault()
    triggerGoogle()
  })

  customBtnEl.addEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      triggerGoogle()
    }
  })

  if (!getGoogle()?.accounts?.id) {
    const script = document.createElement("script")
    script.src = "https://accounts.google.com/gsi/client"
    script.async = true
    script.defer = true
    script.onload = ensureRendered
    document.head.appendChild(script)
  } else {
    ensureRendered()
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGoogleSignIn)
} else {
  initGoogleSignIn()
}
